import { POS_RAIL_EXIT_ID } from './admin-shell-mode.model';

/** Ítems del rail POS que navegan a operación (excluye Salir → Milinco). */
export function countPosOperationalRailItems(
  railItems: readonly { readonly id: number }[]
): number {
  return railItems.filter((item) => item.id !== POS_RAIL_EXIT_ID).length;
}

/**
 * Shell POS con un solo módulo operativo (p. ej. solo Mesas):
 * sin rail lateral; lienzo a ancho completo.
 */
export function isPosImmersiveShell(
  posShell: boolean,
  railItems: readonly { readonly id: number }[]
): boolean {
  return posShell && countPosOperationalRailItems(railItems) === 1;
}
